import Vue from 'vue'
import { obterPreferencias, salvarPreferencia } from '@app/shared/services/preferencia-popup-inicial'

// Campanha Contador CEO Experience 2026 (card 49047).
// Apos a data fim o banner some sozinho e o pop-up anterior volta a ser o primeiro.
const DATA_FIM = '2026-10-15T23:59:59'
const LINK_RESGATE = 'https://chk.eduzz.com/R9JXX57P0X'
const CHAVE_PREFERENCIA = 'ccxIngressoResgatado'
const LARANJA = '#ed7d3e'
const DESCRICAO = 'Você, cliente Monitor Contábil, ganhou um par de ingressos para o Contador CEO Experience 2026. Clique aqui e resgate seu ingresso.'

const banner = require('@/assets/images/popup/ccx-2026.jpg')

function campanhaVigente(hoje = new Date()) {
  return hoje <= new Date(DATA_FIM)
}

/**
 * Exibe o banner da campanha quando ela esta vigente e o usuario ainda nao
 * clicou em "Ja resgatei". Resolve sempre, inclusive quando nao exibe nada,
 * para nao travar o encadeamento das demais modais do login.
 *
 * O texto do alt e o fallback de quem usa leitor de tela ou nao consegue
 * carregar a imagem: o link continua clicavel com ele no lugar da arte.
 *
 * @returns {Promise<boolean>} true se o banner chegou a ser exibido
 */
export default async function exibirBannerCcx() {
  if (!campanhaVigente()) return false

  const preferencias = await obterPreferencias()
  if (preferencias[CHAVE_PREFERENCIA]) return false

  const resultado = await Vue.swal({
    html: `
      <a href="${LINK_RESGATE}" target="_blank" rel="noopener noreferrer" title="Clique aqui e resgate seu ingresso">
        <img src="${banner}" alt="${DESCRICAO}" style="width: 100%; display: block; border-radius: 12px;">
      </a>
    `,
    // Emoji e nao FontAwesome: o projeto carrega o FA apenas como componente SVG,
    // classes como <i class="fa-solid fa-gift"> nao tem CSS e nao renderizam.
    confirmButtonText: '🎁 Já resgatei',
    // O laranja da campanha nao existe como variante de botao do tema, por isso
    // a cor vai direta aqui em vez do padrao buttonsStyling: false do projeto.
    confirmButtonColor: LARANJA,
    showCloseButton: true,
    width: '640px',
    padding: '1rem',
  })

  if (resultado.isConfirmed) {
    await salvarPreferencia(CHAVE_PREFERENCIA, true, preferencias)
  }

  return true
}
